import React from 'react';
import CardList from '../components/CardList';
import {robots} from '../Robots.js';
import SearchBox from '../components/SearchBox.js';
import Scroll from '../components/Scroll.js';
import ErrorBoundary from '../components/ErrorBoundary.js';
import './App.css';
class App extends React.Component {
	constructor(){
		super();
		this.state={
			robots:robots,
			searchField:''
		}
	}

	componentDidMount(){
		fetch('https://jsonplaceholder.typicode.com/users')
			.then(response=>{return response.json();})
			.then(users=>this.setState({ robots: users }))
	}

	onSearchChange = (event) =>{
		this.setState({searchField: event.target.value})
	}

	render (){
		const {robots, searchField} = this.state;
		const filteredRobots = robots.filter(robot =>{
			return robot.name.toLowerCase().includes(searchField.toLowerCase());
		})
		return !robots.length ? <h1>Loading</h1> :
		(
			<div className="tc">
				<h1 className="f2">RoboFriends</h1>
				<SearchBox searchChange={this.onSearchChange} />
				<Scroll>
					<ErrorBoundary>
						<CardList robots={filteredRobots}/>
					</ErrorBoundary>
				</Scroll>
			</div>
		)
	}
}

export default App;